import { Injectable } from '@angular/core';

import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { IModal } from './modal.interface';

@Injectable()
export class ModalService {
    modalRef: NgbModalRef;
    configStore: IModal = {};

    constructor(
        private modalService: NgbModal
    ) {}

    open(content, config = {}): NgbModalRef {
        if (config && !config['windowClass']) { config['windowClass'] = 'sg-modal-default'; }
        this.configStore = config;
        this.modalRef = this.modalService.open(content, config);

        return this.modalRef;
    }

    close(): void {
        if (this.modalRef) {
            this.modalRef.close();
        }
    }

    dismiss(): void {
        if (this.modalRef) {
            this.modalRef.dismiss();
        }
    }
}
